import React, { Component } from 'react';
import { Button, Card, Col, Form, Input, Row, Select } from 'antd';
import { connect } from 'react-redux';
import { queryDeleteAttachment } from '@api/pub/attachment';
import UploadFile from '@comm/upload/UploadFile';
import { goBack } from '@comm/BackBtn';

const { Option } = Select;
const FormItem = Form.Item;

class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      transferType: [
        {
          uuid: '0',
          name: '自营佣金',
        },
        {
          uuid: '1',
          name: '商家活动费',
        },
        {
          uuid: '2',
          name: '其他',
        },
      ],
      delFiles: [],
    };
  }

  componentDidMount() {}

  submit = e => {
    if (e) {
      e.preventDefault();
    }
    const { handSubmit, data } = this.props;
    const expenses = {
      ...data,
      ...this.props.form.getFieldsValue(),
    };
    if (this.apportion) {
      expenses.apportion = this.apportion;
    }
    this.props.form.validateFields((err, values) => {
      if (!err) {
        handSubmit(expenses);
        if (this.state.delFiles.length > 0) {
          this.state.delFiles.map(item => {
            queryDeleteAttachment({
              uuid: item.uuid,
            }).then(res => {
              console.log(res.message);
            });
            return item;
          });
        }
      }
    });
  };

  /**
   *文件删除
   */
  fileRemove = file => {
    const { delFiles } = this.state;
    delFiles.push(file);
    this.setState({ delFiles });
  };

  start = e => {
    this.submit(e, null, 'start');
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { isSubmiting } = this.props;
    const { transferType } = this.state;
    const dataItem = this.props.data;
    const ItemLayout = {
      labelCol: { span: 4 },
      wrapperCol: { span: 12 },
    };
    const ItemLayout2 = {
      labelCol: { span: 8 },
      wrapperCol: { span: 12 },
    };
    return (
      <Form onSubmit={this.submit}>
        <div style={{ marginBottom: '16px' }}>
          <Button icon="left" shape="circle" style={{ marginRight: 10 }} onClick={goBack} />
          <Button
            icon="upload"
            type="primary"
            style={{ marginRight: 10 }}
            onClick={this.start}
            loading={isSubmiting}
          >
            发起申请
          </Button>
          {dataItem.uuid ? (
            <Button icon="delete" style={{ marginRight: 10 }} onClick={this.props.handleDelete}>
              删除
            </Button>
          ) : null}
        </div>
        <Card>
          <Row>
            <Col span={20}>
              <FormItem label="划款类型" {...ItemLayout} style={{ position: 'relative' }}>
                {getFieldDecorator('type', {
                  rules: [{ required: true, message: '请选择划款类型' }],
                  initialValue: `${dataItem.type ? dataItem.type : ''}`,
                })(
                  <Select onChange={this.handleTypeChange}>
                    {transferType.map(item => {
                      return <Option key={item.uuid}>{item.name}</Option>;
                    })}
                  </Select>,
                )}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={20}>
              <FormItem label="划款说明" {...ItemLayout}>
                {getFieldDecorator('reason', {
                  initialValue: dataItem.reason,
                })(
                  <Input.TextArea
                    placeholder="备注"
                    type="textarea"
                    autosize={{ minRows: 3, maxRows: 9 }}
                  />,
                )}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <FormItem label="划款附件" {...ItemLayout2}>
                {getFieldDecorator('files', {
                  rules: [{ required: true, message: '请上传划款附件' }],
                  initialValue: dataItem.files || [],
                })(
                  <UploadFile
                    type="ghost"
                    fileList={dataItem.file}
                    onRemove={this.fileRemove}
                    isPreview
                  />,
                )}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <FormItem label="申请人" {...ItemLayout}>
                {getFieldDecorator('crName', {
                  initialValue: dataItem.createUserName,
                })(<span>{this.props.accountInfo.userName}</span>)}
              </FormItem>
            </Col>
          </Row>
        </Card>
      </Form>
    );
  }
}

export default connect(state => ({
  accountInfo: state.account_info,
}))(Form.create()(BaseForm));



// WEBPACK FOOTER //
// ./src/components/finance/platformTransfer/FormBase.js